<script setup>
import '@/assets/cloudCounter/css/style.css';
import { ref, defineProps, } from 'vue';
import Layout from '@/components/cloudCounter/Layout.vue';
import { useRouter } from 'vue-router';
const router = useRouter();

const goNextPage = () => {
    router.push({ name: 'cloudCounterVideoOperationClause' });
}

</script>

<template>

    <Layout :header="{ text: '視訊作業', backBtn: { visible: true }, closeBtn: { visible: false, to: {} }, }">

        <div class="pt-12 pb-16 text-center">
            <img src="" alt="" v-if="false">
            <div class="mx-auto w-[168px] h-[168px] bg-[#D9D9D9] text-[#CCC]" v-else>
                <div class="inline-block">
                    <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                        style="width: 60px;height: 168px;">
                        <title>image</title>
                        <path
                            d="M8.5,13.5L11,16.5L14.5,12L19,18H5M21,19V5C21,3.89 20.1,3 19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19Z" />
                    </svg>
                </div>
            </div>
        </div>

        <div class="pb-4">
            <h2 class="font-bold text-2xl">
                視訊作業注意事項
            </h2>
            <ul class="list-disc pt-2 pl-6">
                <li>在光線充足的位置，並勿遮擋臉部，臉部需佔畫面的一半。</li>
                <li>準備本人之身分證，於視訊時出示進行身份核對。</li>
                <li>過程中將會全程錄影及錄音，並加密保存。</li>
                <li>麥克風請維持正常音量，周遭環境請保持安靜。</li>
            </ul>
        </div>

        <template v-slot:bottom>
            <button
                class="w-full pt-5 pb-14 text-center bg-[#0093C1] text-white disabled:bg-[#D7D8DA] disabled:text-[#86878F]"
                @click="goNextPage">下一步</button>
        </template>

    </Layout>

</template>

<style scoped></style>
